import React, { useEffect, useState } from 'react';

const Contact = () => {
  const [contact, setContact] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch('/contact.json')
      .then(res => {
        if (!res.ok) throw new Error('Failed to load contact data');
        return res.json();
      })
      .then(setContact)
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <section className="resume-contact"><p>Loading...</p></section>;
  if (error) return <section className="resume-contact"><p>Error: {error}</p></section>;
  if (!contact) return null;

  return (
    <section className="resume-contact">
      <h2>Contact Me</h2>
      <div className="contact-details">
        {Object.entries(contact).map(([key, value]) => (
          <p key={key}>
            <strong>{key.charAt(0).toUpperCase() + key.slice(1)}:</strong>{' '}
            {typeof value === 'string' && value.startsWith('http') ? (
              <a href={value} target="_blank" rel="noopener noreferrer">{value}</a>
            ) : (
              value
            )}
          </p>
        ))}
      </div>
    </section>
  );
};

export default Contact;
